import React, { useRef, useState } from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import { Template } from 'devextreme-react/core/template';
import { UserPanel } from '../user-panel/UserPanel';
import { ThemeSwitcher } from '../theme-switcher/ThemeSwitcher';
import { NotificationBell } from './NotificationBell';
import type { AppHeaderProps } from '../../../types';
import './AppHeader.scss';
import { LanguageSelect } from '../language/select';
import { getFirmName, getImageURL, getVendorId } from '../../../api/session';
import logo from "../../../assets/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight, faChevronUp, faClose, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
 
export const AppHeader = ({
  menuToggleEnabled,
  title,
  toggleMenu,
  className,
  tabs = [],
  activeTabId,
  onTabSelect,
  onAddTab,
  onTabClose,
  canCloseTabs = false,
  closeableTabIds = [],
}: AppHeaderProps) => {
  
  const containerRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const renderTitleParts = (value?: string) => {
    const parts = (value ?? '')
      .split(' - ')
      .map((part) => part.trim())
      .filter(Boolean);

    return parts.map((part, index) => (
      <React.Fragment key={`${part}-${index}`}>
        {index > 0 ? (
          <FontAwesomeIcon icon={faChevronRight} className='title-separator' />
        ) : null}
        <span className={index === 0 ? 'title-primary' : 'title-secondary'}>{part}</span>
      </React.Fragment>
    ));
  };

  return (
    <header className={`header-component ${className} pt-2`}>
      <Toolbar className='header-toolbar'>
        <Item visible={menuToggleEnabled} location='before' widget='dxButton' cssClass='menu-button'>
          <Button icon='menu' stylingMode='text' onClick={toggleMenu} />
        </Item>
        <Item location='before' cssClass='header-title'>
          <img src={logo} className='w-44 sag-bosluk'></img>
        </Item>
 
        <Item location='before' locateInMenu="auto" cssClass='header-title-tabs'>
          <div className='header-tabs'>
            {tabs.length > 0 ? tabs.map((tab) => (
              <div
                key={tab.id}
                className={`header-tab ${tab.id === activeTabId ? 'active' : ''} ${tab.id === 'split' ? 'split' : ''}`}
                title={tab.title}
              >
                <button
                  type='button'
                  className='header-tab-label'
                  onClick={() => onTabSelect?.(tab.id)}
                >
                  {tab.icon && <i className={`dx-icon-${tab.icon} header-tab-icon`} />}
                  <span className='header-tab-title-text'>{renderTitleParts(tab.title)}</span>
                </button>
                {onTabClose && closeableTabIds.includes(tab.id) ? (
                  <button
                    type='button'
                    className='header-tab-close'
                    onClick={(e) => {
                      e.stopPropagation();
                      onTabClose?.(tab.id);
                    }}
                    disabled={!canCloseTabs}
                    title={canCloseTabs ? t('close') : t('Son sekme kapatılamaz')}
                  >
                    <FontAwesomeIcon icon={faClose}  />
                  </button>
                ) : null}
              </div>
            )) : (
              <div className='header-title-text'>{renderTitleParts(title)}</div>
            )}
            {onAddTab ? (
              <button
                type='button'
                className='add-tab-button'
                onClick={() => onAddTab?.()}
                title='Yeni sekme'
              >
                <FontAwesomeIcon icon={faPlus} />
              </button>
            ) : null}
          </div>
        </Item> 
 
        <Item location="after" locateInMenu='auto'>
          <div className='text-right mr-2.5 '>
            <div>{getFirmName()}</div>
            <div style={{ fontSize: 11 }}>{getVendorId()}</div>
          </div>
        </Item>
 
        <Item location="after" locateInMenu="auto">
        </Item>
 
 
        <Item location='after' locateInMenu='auto'>
          <div className='separator' />
        </Item>
 
       
        <Item location='after' locateInMenu='never'>
          <ThemeSwitcher />
        </Item>
        <Item location='after'>
          <LanguageSelect />
        </Item>
 
        <Item location='after' locateInMenu='auto' menuItemTemplate='userPanelTemplate'>
          <UserPanel menuMode='context' />
        </Item>
        <Template name='userPanelTemplate'>
          <UserPanel menuMode='list' />
        </Template>
      </Toolbar>
    </header>
  );
};
 
 